export default __webpack_public_path__ + "static/media/facebook.455d062a.svg";